import React, { useState, useEffect } from 'react';
import { 
  TextField, 
  Grid, 
  MenuItem, 
  FormControl, 
  InputLabel, 
  FormHelperText,
  InputAdornment,
  Typography,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import FormSelect from './FormSelect';


// Comprehensive list of countries with phone codes (alphabetically sorted)
let countries = [
  { code: 'ZA', name: 'Afrique du Sud', dialCode: '+27', format: 'XX XXX XXXX', placeholder: '71 123 4567', minLength: 9, maxLength: 9 },
  { code: 'AL', name: 'Albanie', dialCode: '+355', format: 'XX XXX XXXX', placeholder: '69 123 4567', minLength: 9, maxLength: 9 },
  { code: 'DZ', name: 'Algérie', dialCode: '+213', format: 'XXX XX XX XX', placeholder: '551 23 45 67', minLength: 9, maxLength: 9 },
  { code: 'DE', name: 'Allemagne', dialCode: '+49', format: 'XXXX XXXXXXX', placeholder: '1701 2345678', minLength: 10, maxLength: 11 },
  { code: 'AD', name: 'Andorre', dialCode: '+376', format: 'XXX XXX', placeholder: '312 345', minLength: 6, maxLength: 6 },
  { code: 'AO', name: 'Angola', dialCode: '+244', format: 'XXX XXX XXX', placeholder: '923 456 789', minLength: 9, maxLength: 9 },
  { code: 'SA', name: 'Arabie saoudite', dialCode: '+966', format: 'XX XXX XXXX', placeholder: '50 123 4567', minLength: 9, maxLength: 9 },
  { code: 'AR', name: 'Argentine', dialCode: '+54', format: 'XX XXXX XXXX', placeholder: '11 1234 5678', minLength: 10, maxLength: 10 },
  { code: 'AM', name: 'Arménie', dialCode: '+374', format: 'XX XXX XXX', placeholder: '77 123 456', minLength: 8, maxLength: 8 },
  { code: 'AU', name: 'Australie', dialCode: '+61', format: 'XXX XXX XXX', placeholder: '412 345 678', minLength: 9, maxLength: 9 },
  { code: 'AT', name: 'Autriche', dialCode: '+43', format: 'XXX XXXXXX', placeholder: '664 123456', minLength: 9, maxLength: 10 },
  { code: 'AZ', name: 'Azerbaïdjan', dialCode: '+994', format: 'XX XXX XX XX', placeholder: '50 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'CA', name: 'Canada', dialCode: '+1', format: 'XXX XXX XXXX', placeholder: '416 555 0123', minLength: 10, maxLength: 10 },
  { code: 'FR', name: 'France', dialCode: '+33', format: 'X XX XX XX XX', placeholder: '6 12 34 56 78', minLength: 9, maxLength: 9 },
  { code: 'MG', name: 'Madagascar', dialCode: '+261', format: 'XX XX XXX XX', placeholder: '32 12 345 67', minLength: 9, maxLength: 10 },
  { code: 'MU', name: 'Maurice', dialCode: '+230', format: 'XXXX XXXX', placeholder: '5712 3456', minLength: 8, maxLength: 8 },
  { code: 'MA', name: 'Maroc', dialCode: '+212', format: 'XX XXX XXXX', placeholder: '61 234 5678', minLength: 9, maxLength: 9 },
  { code: 'SN', name: 'Sénégal', dialCode: '+221', format: 'XX XXX XX XX', placeholder: '70 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'CM', name: 'Cameroun', dialCode: '+237', format: 'X XX XX XX XX', placeholder: '6 98 76 54 32', minLength: 9, maxLength: 9 },
  { code: 'CI', name: 'Côte d\'Ivoire', dialCode: '+225', format: 'XX XX XX XX XX', placeholder: '07 12 34 56 78', minLength: 10, maxLength: 10 },
  { code: 'US', name: 'États-Unis', dialCode: '+1', format: 'XXX XXX XXXX', placeholder: '212 555 0123', minLength: 10, maxLength: 10 },
  { code: 'GB', name: 'Royaume-Uni', dialCode: '+44', format: 'XXXX XXXXXX', placeholder: '7700 900123', minLength: 10, maxLength: 10 },
  { code: 'BE', name: 'Belgique', dialCode: '+32', format: 'XXX XX XX XX', placeholder: '470 12 34 56', minLength: 9, maxLength: 9 },
  { code: 'CH', name: 'Suisse', dialCode: '+41', format: 'XX XXX XX XX', placeholder: '79 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'AF', name: 'Afghanistan', dialCode: '+93', format: 'XX XXX XXXX', placeholder: '70 123 4567', minLength: 9, maxLength: 9 },
  { code: 'ZW', name: 'Zimbabwe', dialCode: '+263', format: 'XX XXX XXXX', placeholder: '71 234 5678', minLength: 9, maxLength: 9 },
  { code: 'BJ', name: 'Bénin', dialCode: '+229', format: 'XX XXX XXX', placeholder: '90 123 456', minLength: 8, maxLength: 8 },
  { code: 'BR', name: 'Brésil', dialCode: '+55', format: 'XX XXXXX XXXX', placeholder: '11 98765 4321', minLength: 10, maxLength: 11 },
  { code: 'BG', name: 'Bulgarie', dialCode: '+359', format: 'XXX XXX XXX', placeholder: '887 123 456', minLength: 9, maxLength: 9 },
  { code: 'BF', name: 'Burkina Faso', dialCode: '+226', format: 'XX XX XX XX', placeholder: '70 12 34 56', minLength: 8, maxLength: 8 },
  { code: 'BI', name: 'Burundi', dialCode: '+257', format: 'XX XX XX XX', placeholder: '79 12 34 56', minLength: 8, maxLength: 8 },
  { code: 'KH', name: 'Cambodge', dialCode: '+855', format: 'XX XXX XXX', placeholder: '12 345 678', minLength: 8, maxLength: 9 },
  { code: 'TD', name: 'Tchad', dialCode: '+235', format: 'XX XX XX XX', placeholder: '63 12 34 56', minLength: 8, maxLength: 8 },
  { code: 'CL', name: 'Chili', dialCode: '+56', format: 'X XXXX XXXX', placeholder: '9 1234 5678', minLength: 9, maxLength: 9 },
  { code: 'CN', name: 'Chine', dialCode: '+86', format: 'XXX XXXX XXXX', placeholder: '139 1234 5678', minLength: 11, maxLength: 11 },
  { code: 'CO', name: 'Colombie', dialCode: '+57', format: 'XXX XXX XXXX', placeholder: '320 123 4567', minLength: 10, maxLength: 10 },
  { code: 'KM', name: 'Comores', dialCode: '+269', format: 'XXX XXXX', placeholder: '321 2345', minLength: 7, maxLength: 7 },
  { code: 'CG', name: 'Congo', dialCode: '+242', format: 'XX XXX XXXX', placeholder: '06 123 4567', minLength: 9, maxLength: 9 },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', format: 'XXXX XXXX', placeholder: '8312 3456', minLength: 8, maxLength: 8 },
  { code: 'HR', name: 'Croatie', dialCode: '+385', format: 'XX XXX XXXX', placeholder: '95 123 4567', minLength: 9, maxLength: 9 },
  { code: 'CU', name: 'Cuba', dialCode: '+53', format: 'X XXXX XXXX', placeholder: '5 1234 5678', minLength: 8, maxLength: 10 },
  { code: 'CY', name: 'Chypre', dialCode: '+357', format: 'XX XXXXXX', placeholder: '96 123456', minLength: 8, maxLength: 8 },
  { code: 'CZ', name: 'République tchèque', dialCode: '+420', format: 'XXX XXX XXX', placeholder: '601 123 456', minLength: 9, maxLength: 9 },
  { code: 'DK', name: 'Danemark', dialCode: '+45', format: 'XXXX XXXX', placeholder: '2012 3456', minLength: 8, maxLength: 8 },
  { code: 'DJ', name: 'Djibouti', dialCode: '+253', format: 'XX XX XX XX', placeholder: '77 83 10 01', minLength: 8, maxLength: 8 },
  { code: 'EC', name: 'Équateur', dialCode: '+593', format: 'XX XXX XXXX', placeholder: '99 123 4567', minLength: 9, maxLength: 9 },
  { code: 'EG', name: 'Égypte', dialCode: '+20', format: 'XX XXXX XXXX', placeholder: '10 1234 5678', minLength: 10, maxLength: 10 },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', format: 'XXXX XXXX', placeholder: '7123 4567', minLength: 8, maxLength: 8 },
  { code: 'GQ', name: 'Guinée équatoriale', dialCode: '+240', format: 'XXX XXX XXX', placeholder: '222 123 456', minLength: 9, maxLength: 9 },
  { code: 'ER', name: 'Érythrée', dialCode: '+291', format: 'X XXX XXX', placeholder: '7 123 456', minLength: 7, maxLength: 7 },
  { code: 'EE', name: 'Estonie', dialCode: '+372', format: 'XXXX XXXX', placeholder: '5123 4567', minLength: 7, maxLength: 8 },
  { code: 'ET', name: 'Éthiopie', dialCode: '+251', format: 'XX XXX XXXX', placeholder: '91 123 4567', minLength: 9, maxLength: 9 },
  { code: 'FJ', name: 'Fidji', dialCode: '+679', format: 'XXX XXXX', placeholder: '701 2345', minLength: 7, maxLength: 7 },
  { code: 'FI', name: 'Finlande', dialCode: '+358', format: 'XX XXX XXXX', placeholder: '40 123 4567', minLength: 9, maxLength: 10 },
  { code: 'GA', name: 'Gabon', dialCode: '+241', format: 'X XX XX XX XX', placeholder: '6 12 34 56 78', minLength: 9, maxLength: 9 },
  { code: 'GM', name: 'Gambie', dialCode: '+220', format: 'XXX XXXX', placeholder: '301 2345', minLength: 7, maxLength: 7 },
  { code: 'GE', name: 'Géorgie', dialCode: '+995', format: 'XXX XXX XXX', placeholder: '555 123 456', minLength: 9, maxLength: 9 },
  { code: 'GH', name: 'Ghana', dialCode: '+233', format: 'XX XXX XXXX', placeholder: '24 123 4567', minLength: 9, maxLength: 9 },
  { code: 'GR', name: 'Grèce', dialCode: '+30', format: 'XXX XXX XXXX', placeholder: '697 123 4567', minLength: 10, maxLength: 10 },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', format: 'X XXX XXXX', placeholder: '5 123 4567', minLength: 8, maxLength: 8 },
  { code: 'GN', name: 'Guinée', dialCode: '+224', format: 'XXX XXX XXX', placeholder: '601 123 456', minLength: 9, maxLength: 9 },
  { code: 'GW', name: 'Guinée-Bissau', dialCode: '+245', format: 'XXX XXXX', placeholder: '955 6789', minLength: 7, maxLength: 7 },
  { code: 'HT', name: 'Haïti', dialCode: '+509', format: 'XXXX XXXX', placeholder: '3456 7890', minLength: 8, maxLength: 8 },
  { code: 'HN', name: 'Honduras', dialCode: '+504', format: 'XXXX XXXX', placeholder: '9123 4567', minLength: 8, maxLength: 8 },
  { code: 'HK', name: 'Hong Kong', dialCode: '+852', format: 'XXXX XXXX', placeholder: '6123 4567', minLength: 8, maxLength: 8 },
  { code: 'HU', name: 'Hongrie', dialCode: '+36', format: 'XX XXX XXXX', placeholder: '30 123 4567', minLength: 9, maxLength: 9 },
  { code: 'IS', name: 'Islande', dialCode: '+354', format: 'XXX XXXX', placeholder: '661 2345', minLength: 7, maxLength: 7 },
  { code: 'IN', name: 'Inde', dialCode: '+91', format: 'XXXXX XXXXX', placeholder: '98765 43210', minLength: 10, maxLength: 10 },
  { code: 'ID', name: 'Indonésie', dialCode: '+62', format: 'XXX XXXX XXXX', placeholder: '812 345 6789', minLength: 10, maxLength: 12 },
  { code: 'IR', name: 'Iran', dialCode: '+98', format: 'XXX XXX XXXX', placeholder: '912 345 6789', minLength: 10, maxLength: 10 },
  { code: 'IQ', name: 'Irak', dialCode: '+964', format: 'XXX XXX XXXX', placeholder: '790 123 4567', minLength: 10, maxLength: 10 },
  { code: 'IE', name: 'Irlande', dialCode: '+353', format: 'XX XXX XXXX', placeholder: '85 123 4567', minLength: 9, maxLength: 9 },
  { code: 'IL', name: 'Israël', dialCode: '+972', format: 'XX XXX XXXX', placeholder: '50 123 4567', minLength: 9, maxLength: 9 },
  { code: 'IT', name: 'Italie', dialCode: '+39', format: 'XXX XXX XXXX', placeholder: '312 345 6789', minLength: 10, maxLength: 10 },
  { code: 'JM', name: 'Jamaïque', dialCode: '+1876', format: 'XXX XXXX', placeholder: '876 5432', minLength: 7, maxLength: 7 },
  { code: 'JP', name: 'Japon', dialCode: '+81', format: 'XX XXXX XXXX', placeholder: '90 1234 5678', minLength: 10, maxLength: 10 },
  { code: 'JO', name: 'Jordanie', dialCode: '+962', format: 'X XXXX XXXX', placeholder: '7 9012 3456', minLength: 9, maxLength: 9 },
  { code: 'KZ', name: 'Kazakhstan', dialCode: '+7', format: 'XXX XXX XX XX', placeholder: '700 123 45 67', minLength: 10, maxLength: 10 },
  { code: 'KE', name: 'Kenya', dialCode: '+254', format: 'XXX XXX XXX', placeholder: '712 345 678', minLength: 9, maxLength: 9 },
  { code: 'KI', name: 'Kiribati', dialCode: '+686', format: 'XXXXX', placeholder: '30123', minLength: 5, maxLength: 5 },
  { code: 'KW', name: 'Koweït', dialCode: '+965', format: 'XXXX XXXX', placeholder: '5123 4567', minLength: 8, maxLength: 8 },
  { code: 'KG', name: 'Kirghizistan', dialCode: '+996', format: 'XXX XXX XXX', placeholder: '700 123 456', minLength: 9, maxLength: 9 },
  { code: 'LA', name: 'Laos', dialCode: '+856', format: 'XX XX XXX XXX', placeholder: '20 23 456 789', minLength: 9, maxLength: 10 },
  { code: 'LV', name: 'Lettonie', dialCode: '+371', format: 'XXXX XXXX', placeholder: '2123 4567', minLength: 8, maxLength: 8 },
  { code: 'LB', name: 'Liban', dialCode: '+961', format: 'XX XXX XXX', placeholder: '71 123 456', minLength: 8, maxLength: 8 },
  { code: 'LS', name: 'Lesotho', dialCode: '+266', format: 'XX XXX XXX', placeholder: '50 123 456', minLength: 8, maxLength: 8 },
  { code: 'LR', name: 'Libéria', dialCode: '+231', format: 'XX XXX XXXX', placeholder: '77 012 3456', minLength: 8, maxLength: 8 },
  { code: 'LY', name: 'Libye', dialCode: '+218', format: 'XX XXX XXXX', placeholder: '91 234 5678', minLength: 9, maxLength: 9 },
  { code: 'LI', name: 'Liechtenstein', dialCode: '+423', format: 'XXX XXXX', placeholder: '660 1234', minLength: 7, maxLength: 7 },
  { code: 'LT', name: 'Lituanie', dialCode: '+370', format: 'XXX XXXXX', placeholder: '612 34567', minLength: 8, maxLength: 8 },
  { code: 'LU', name: 'Luxembourg', dialCode: '+352', format: 'XXX XXX XXX', placeholder: '628 123 456', minLength: 9, maxLength: 9 },
  { code: 'MO', name: 'Macao', dialCode: '+853', format: 'XXXX XXXX', placeholder: '6612 3456', minLength: 8, maxLength: 8 },
  { code: 'MK', name: 'Macédoine du Nord', dialCode: '+389', format: 'XX XXX XXX', placeholder: '72 345 678', minLength: 8, maxLength: 8 },
  { code: 'MW', name: 'Malawi', dialCode: '+265', format: 'XX XXX XXXX', placeholder: '88 123 4567', minLength: 9, maxLength: 9 },
  { code: 'MY', name: 'Malaisie', dialCode: '+60', format: 'XX XXX XXXX', placeholder: '12 345 6789', minLength: 9, maxLength: 10 },
  { code: 'MV', name: 'Maldives', dialCode: '+960', format: 'XXX XXXX', placeholder: '771 2345', minLength: 7, maxLength: 7 },
  { code: 'ML', name: 'Mali', dialCode: '+223', format: 'XXXX XXXX', placeholder: '6712 3456', minLength: 8, maxLength: 8 },
  { code: 'MT', name: 'Malte', dialCode: '+356', format: 'XXXX XXXX', placeholder: '9696 9696', minLength: 8, maxLength: 8 },
  { code: 'MH', name: 'Îles Marshall', dialCode: '+692', format: 'XXX XXXX', placeholder: '235 6789', minLength: 7, maxLength: 7 },
  { code: 'MR', name: 'Mauritanie', dialCode: '+222', format: 'XXXX XXXX', placeholder: '4123 4567', minLength: 8, maxLength: 8 },
  { code: 'MX', name: 'Mexique', dialCode: '+52', format: 'XXX XXX XXXX', placeholder: '222 123 4567', minLength: 10, maxLength: 10 },
  { code: 'FM', name: 'Micronésie', dialCode: '+691', format: 'XXX XXXX', placeholder: '350 1234', minLength: 7, maxLength: 7 },
  { code: 'MD', name: 'Moldavie', dialCode: '+373', format: 'XXX XX XXX', placeholder: '621 12 345', minLength: 8, maxLength: 8 },
  { code: 'MC', name: 'Monaco', dialCode: '+377', format: 'XX XX XX XX', placeholder: '06 12 34 56', minLength: 8, maxLength: 8 },
  { code: 'MN', name: 'Mongolie', dialCode: '+976', format: 'XXXX XXXX', placeholder: '8812 3456', minLength: 8, maxLength: 8 },
  { code: 'ME', name: 'Monténégro', dialCode: '+382', format: 'XX XXX XXX', placeholder: '67 622 901', minLength: 8, maxLength: 8 },
  { code: 'MZ', name: 'Mozambique', dialCode: '+258', format: 'XX XXX XXXX', placeholder: '82 123 4567', minLength: 9, maxLength: 9 },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', format: 'X XXX XXXX', placeholder: '9 123 4567', minLength: 8, maxLength: 10 },
  { code: 'NA', name: 'Namibie', dialCode: '+264', format: 'XX XXX XXXX', placeholder: '81 123 4567', minLength: 9, maxLength: 9 },
  { code: 'NR', name: 'Nauru', dialCode: '+674', format: 'XXX XXXX', placeholder: '555 1234', minLength: 7, maxLength: 7 },
  { code: 'NP', name: 'Népal', dialCode: '+977', format: 'XXX XXX XXXX', placeholder: '984 123 4567', minLength: 10, maxLength: 10 },
  { code: 'NL', name: 'Pays-Bas', dialCode: '+31', format: 'X XX XX XX XX', placeholder: '6 12 34 56 78', minLength: 9, maxLength: 9 },
  { code: 'NZ', name: 'Nouvelle-Zélande', dialCode: '+64', format: 'XX XXX XXXX', placeholder: '21 123 4567', minLength: 9, maxLength: 10 },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', format: 'XXXX XXXX', placeholder: '8123 4567', minLength: 8, maxLength: 8 },
  { code: 'NE', name: 'Niger', dialCode: '+227', format: 'XX XX XX XX', placeholder: '93 12 34 56', minLength: 8, maxLength: 8 },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', format: 'XXX XXX XXXX', placeholder: '805 123 4567', minLength: 10, maxLength: 10 },
  { code: 'KP', name: 'Corée du Nord', dialCode: '+850', format: 'XX XXX XXXX', placeholder: '19 123 4567', minLength: 10, maxLength: 10 },
  { code: 'NO', name: 'Norvège', dialCode: '+47', format: 'XXX XX XXX', placeholder: '406 12 345', minLength: 8, maxLength: 8 },
  { code: 'OM', name: 'Oman', dialCode: '+968', format: 'XXXX XXXX', placeholder: '9123 4567', minLength: 8, maxLength: 8 },
  { code: 'PK', name: 'Pakistan', dialCode: '+92', format: 'XXX XXX XXXX', placeholder: '300 123 4567', minLength: 10, maxLength: 10 },
  { code: 'PW', name: 'Palaos', dialCode: '+680', format: 'XXX XXXX', placeholder: '620 1234', minLength: 7, maxLength: 7 },
  { code: 'PS', name: 'Palestine', dialCode: '+970', format: 'XXX XXX XXX', placeholder: '599 123 456', minLength: 9, maxLength: 9 },
  { code: 'PA', name: 'Panama', dialCode: '+507', format: 'XXXX XXXX', placeholder: '6123 4567', minLength: 8, maxLength: 8 },
  { code: 'PG', name: 'Papouasie-Nouvelle-Guinée', dialCode: '+675', format: 'XXX XXXX', placeholder: '680 1234', minLength: 7, maxLength: 8 },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', format: 'XXX XXX XXX', placeholder: '971 234 567', minLength: 9, maxLength: 9 },
  { code: 'PE', name: 'Pérou', dialCode: '+51', format: 'XXX XXX XXX', placeholder: '912 345 678', minLength: 9, maxLength: 9 },
  { code: 'PH', name: 'Philippines', dialCode: '+63', format: 'XXX XXX XXXX', placeholder: '916 123 4567', minLength: 10, maxLength: 10 },
  { code: 'PL', name: 'Pologne', dialCode: '+48', format: 'XXX XXX XXX', placeholder: '512 345 678', minLength: 9, maxLength: 9 },
  { code: 'PT', name: 'Portugal', dialCode: '+351', format: 'XXX XXX XXX', placeholder: '912 345 678', minLength: 9, maxLength: 9 },
  { code: 'QA', name: 'Qatar', dialCode: '+974', format: 'XXXX XXXX', placeholder: '3312 3456', minLength: 8, maxLength: 8 },
  { code: 'KR', name: 'Corée du Sud', dialCode: '+82', format: 'XX XXXX XXXX', placeholder: '10 1234 5678', minLength: 9, maxLength: 10 },
  { code: 'RU', name: 'Russie', dialCode: '+7', format: 'XXX XXX XX XX', placeholder: '912 345 67 89', minLength: 10, maxLength: 10 },
  { code: 'RW', name: 'Rwanda', dialCode: '+250', format: 'XXX XXX XXX', placeholder: '722 123 456', minLength: 9, maxLength: 9 },
  { code: 'SM', name: 'Saint-Marin', dialCode: '+378', format: 'XXXX XXXXXX', placeholder: '6661 212345', minLength: 6, maxLength: 10 },
  { code: 'ST', name: 'Sao Tomé-et-Principe', dialCode: '+239', format: 'XX XXXXX', placeholder: '98 12345', minLength: 7, maxLength: 7 },
  { code: 'SG', name: 'Singapour', dialCode: '+65', format: 'XXXX XXXX', placeholder: '9123 4567', minLength: 8, maxLength: 8 },
  { code: 'SK', name: 'Slovaquie', dialCode: '+421', format: 'XXX XXX XXX', placeholder: '912 123 456', minLength: 9, maxLength: 9 },
  { code: 'SI', name: 'Slovénie', dialCode: '+386', format: 'XX XXX XXX', placeholder: '31 234 567', minLength: 8, maxLength: 8 },
  { code: 'SO', name: 'Somalie', dialCode: '+252', format: 'XX XXX XXX', placeholder: '61 732 445', minLength: 8, maxLength: 9 },
  { code: 'ES', name: 'Espagne', dialCode: '+34', format: 'XXX XXX XXX', placeholder: '612 345 678', minLength: 9, maxLength: 9 },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', format: 'XX XXX XXXX', placeholder: '71 234 5678', minLength: 9, maxLength: 9 },
  { code: 'SD', name: 'Soudan', dialCode: '+249', format: 'XX XXX XXXX', placeholder: '91 123 4567', minLength: 9, maxLength: 9 },
  { code: 'SR', name: 'Suriname', dialCode: '+597', format: 'XXX XXXX', placeholder: '741 2345', minLength: 7, maxLength: 7 },
  { code: 'SZ', name: 'Eswatini', dialCode: '+268', format: 'XXXX XXXX', placeholder: '7612 3456', minLength: 8, maxLength: 8 },
  { code: 'SE', name: 'Suède', dialCode: '+46', format: 'XX XXX XX XX', placeholder: '70 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'SY', name: 'Syrie', dialCode: '+963', format: 'XXX XXX XXX', placeholder: '944 567 890', minLength: 9, maxLength: 10 },
  { code: 'TW', name: 'Taïwan', dialCode: '+886', format: 'XXX XXX XXX', placeholder: '912 345 678', minLength: 9, maxLength: 9 },
  { code: 'TJ', name: 'Tadjikistan', dialCode: '+992', format: 'XX XXX XXXX', placeholder: '93 123 4567', minLength: 9, maxLength: 9 },
  { code: 'TZ', name: 'Tanzanie', dialCode: '+255', format: 'XXX XXX XXX', placeholder: '712 345 678', minLength: 9, maxLength: 9 },
  { code: 'TH', name: 'Thaïlande', dialCode: '+66', format: 'X XXXX XXXX', placeholder: '8 1234 5678', minLength: 9, maxLength: 9 },
  { code: 'TL', name: 'Timor oriental', dialCode: '+670', format: 'XXXX XXXX', placeholder: '7723 4567', minLength: 8, maxLength: 8 },
  { code: 'TG', name: 'Togo', dialCode: '+228', format: 'XX XXX XXX', placeholder: '90 112 345', minLength: 8, maxLength: 8 },
  { code: 'TO', name: 'Tonga', dialCode: '+676', format: 'XXXXX', placeholder: '71234', minLength: 5, maxLength: 7 },
  { code: 'TT', name: 'Trinité-et-Tobago', dialCode: '+1868', format: 'XXX XXXX', placeholder: '868 7890', minLength: 7, maxLength: 7 },
  { code: 'TN', name: 'Tunisie', dialCode: '+216', format: 'XX XXX XXX', placeholder: '20 123 456', minLength: 8, maxLength: 8 },
  { code: 'TR', name: 'Turquie', dialCode: '+90', format: 'XXX XXX XXXX', placeholder: '532 123 4567', minLength: 10, maxLength: 10 },
  { code: 'TM', name: 'Turkménistan', dialCode: '+993', format: 'XX XXXXXX', placeholder: '66 123456', minLength: 8, maxLength: 8 },
  { code: 'TV', name: 'Tuvalu', dialCode: '+688', format: 'XXXXX', placeholder: '20123', minLength: 5, maxLength: 6 },
  { code: 'UG', name: 'Ouganda', dialCode: '+256', format: 'XXX XXX XXX', placeholder: '712 345 678', minLength: 9, maxLength: 9 },
  { code: 'UA', name: 'Ukraine', dialCode: '+380', format: 'XX XXX XX XX', placeholder: '50 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'AE', name: 'Émirats arabes unis', dialCode: '+971', format: 'XX XXX XXXX', placeholder: '50 123 4567', minLength: 9, maxLength: 9 },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', format: 'X XXX XXXX', placeholder: '9 234 5678', minLength: 8, maxLength: 8 },
  { code: 'UZ', name: 'Ouzbékistan', dialCode: '+998', format: 'XX XXX XX XX', placeholder: '90 123 45 67', minLength: 9, maxLength: 9 },
  { code: 'VU', name: 'Vanuatu', dialCode: '+678', format: 'XXXXX', placeholder: '59123', minLength: 5, maxLength: 7 },
  { code: 'VA', name: 'Vatican', dialCode: '+39', format: 'XXX XXX XXXX', placeholder: '312 345 6789', minLength: 10, maxLength: 10 },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', format: 'XXX XXX XXXX', placeholder: '412 123 4567', minLength: 10, maxLength: 10 },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', format: 'XXX XXX XX XX', placeholder: '912 345 67 89', minLength: 9, maxLength: 10 },
  { code: 'YE', name: 'Yémen', dialCode: '+967', format: 'XXX XXX XXX', placeholder: '712 345 678', minLength: 9, maxLength: 9 },
  { code: 'ZM', name: 'Zambie', dialCode: '+260', format: 'XX XXX XXXX', placeholder: '95 123 4567', minLength: 9, maxLength: 9 },
].sort((a, b) => a.name.localeCompare(b.name, 'en')); // Sort alphabetically by country name (English)

// Derive English names dynamically from ISO codes to ensure English UI labels
let countriesList = countries;
try {
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  countriesList = countries.map((c) => ({ ...c, name: regionNames.of(c.code) || c.name }));
} catch (e) {
  countriesList = countries;
}

// Style for the flag box
const FlagBox = styled(Box)(({ theme }) => ({
  width: 24,
  height: 16,
  marginRight: theme.spacing(1),
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  border: '1px solid #ddd',
  borderRadius: 2
}));
// Simple validation for phone numbers
const isValidPhoneNumber = (number, country) => {
  // Remove spaces, dashes and other non-digit characters for validation
  const digits = number.replace(/\D/g, '');
  
  // Check if the number matches the expected length for the country
  return digits.length >= country.minLength && digits.length <= country.maxLength;
};

const PhoneInput = ({ 
  value, 
  onChange, 
  error, 
  helperText, 
  label = "Phone", 
  required = false,
  name = "phone",
  fullWidth = true,
  inputProps = {},
  showFlags = true,
  ...props
}) => {
  // Parse the initial value if it exists
  const [selectedCountry, setSelectedCountry] = useState(countriesList[0]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [localError, setLocalError] = useState('');
  useEffect(() => {
    // Try to parse existing value if it contains country code
    if (value && value.trim() !== '') {
      try {
        // Check if the value includes a + sign (has country code)
        if (value.includes('+')) {
          // Find the country by dial code
          const dialCodePart = value.split(' ')[0];
          const country = countriesList.find(c => c.dialCode === dialCodePart);
          
          if (country) {
            setSelectedCountry(country);
            // Set the national number without country code
            setPhoneNumber(value.replace(dialCodePart, '').trim());
          } else {
            // If country not found in our list, just use the value
            setPhoneNumber(value.replace(selectedCountry.dialCode, '').trim());
          }
        } else {
          // No country code in the value, just set the number
          setPhoneNumber(value);
        }
      } catch (err) {
        console.error("Error parsing phone number:", err);
        setPhoneNumber(value);
      }
    } else {
      setPhoneNumber('');
    }
  }, [value]);

  // Handle country change
  const handleCountryChange = (event) => {
    const newCountry = countriesList.find(c => c.code === event.target.value);
    if (newCountry) {
      setSelectedCountry(newCountry);
      validateAndNotify(phoneNumber, newCountry);
    }
  };

  // Handle phone number change
  const handlePhoneChange = (event) => {
    const input = event.target.value;
    
    // Allow only digits, spaces, and dashes for formatting
    const sanitizedInput = input.replace(/[^\d\s-]/g, '');
    
    setPhoneNumber(sanitizedInput);
    validateAndNotify(sanitizedInput, selectedCountry);
  };

  // Validate the phone number
  const validateAndNotify = (number, country) => {
    // Skip validation if empty (unless required)
    if (!number || number.trim() === '') {
      setLocalError(required ? 'Le numéro de téléphone est requis' : '');
      // Call parent onChange with empty value
      onChange({
        target: {
          name,
          value: ''
        }
      });
      return;
    }

    const fullNumber = `${country.dialCode} ${number.replace(/\s+/g, '')}`;
    
    try {
      const isValid = isValidPhoneNumber(number, country);
      
      if (isValid) {
        setLocalError('');
        // Call parent onChange with the formatted value
        onChange({
          target: {
            name,
            value: fullNumber
          }
        });
      } else {
        setLocalError(`Format invalide pour ${country.name} (${country.minLength}-${country.maxLength} chiffres)`);
        // Still call parent onChange to allow form submission with error state
        onChange({
          target: {
            name,
            value: fullNumber
          }
        });
      }
    } catch (err) {
      console.error("Error validating phone number:", err);
      setLocalError('Erreur de validation');
      onChange({
        target: {
          name,
          value: fullNumber
        }
      });
    }
  };

  // Flag URL generator
  const getFlagUrl = (countryCode) => {
    return `https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`;
  };

  // Determine if we should show error from props or local error
  const showError = error || localError;
  const showHelperText = helperText || localError;

  // Format country options for FormSelect
  // Each option has:
  // - id: country code (e.g., 'FR')
  // - title: React element showing only the flag (for selected state)
  // - fullName: country name (shown in dropdown)
  const countryOptions = countriesList.map(country => {
    // English display name from region code
    let englishName = country.name;
    try {
      const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
      englishName = regionNames.of(country.code) || country.name;
    } catch (e) {
      englishName = country.name;
    }
    return {
      id: country.code,
      // Dropdown label (names only)
      title: englishName,
      // Selected view rendering
      selectedTitle: showFlags ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 1 }}>
          <FlagBox 
            sx={{ 
              backgroundImage: `url(${getFlagUrl(country.code)})`,
              marginRight: 0
            }} 
          />
          <Typography variant="body2" color="text.primary">{country.dialCode}</Typography>
        </Box>
      ) : (
        <Typography variant="body2" color="text.primary">{englishName}</Typography>
      ),
      // Keep for future use
      fullName: englishName
    };
  });

  // Helper to get the selected country's dial code for display
  const getSelectedCountryDialCode = () => {
    return selectedCountry ? selectedCountry.dialCode : '+';
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      {/* Country selector without label - flag only */}
      <Box sx={{ width: showFlags ? '90px' : '56px', marginRight: '8px' }}>
        <FormSelect
          name="country-code"
          value={selectedCountry.code}
          onChange={handleCountryChange}
          options={countryOptions}
          hideLabel
          size="small"
        />
      </Box>

      {/* Phone number input with label */}
      <Box sx={{ flex: 1 }}>
        <TextField
          fullWidth
          name={name}
          value={phoneNumber}
          onChange={handlePhoneChange}
          onBlur={(e) => props.onBlur && props.onBlur(e)}
          label={required ? `${label} *` : label}
          variant="outlined"
          error={!!showError}
          helperText={showHelperText}
          placeholder={selectedCountry.placeholder}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="body2" color="text.secondary">
                  {selectedCountry.dialCode}
                </Typography>
              </InputAdornment>
            ),
            ...inputProps
          }}
          title={`Format: ${selectedCountry.dialCode} ${selectedCountry.format}`}
          {...props}
          sx={{ 
            '& .MuiInputBase-root': { height: '56px' }
          }}
        />
      </Box>
    </Box>
  );
};

export default PhoneInput; 